import { RootState } from '../types/graph';

export const selectVersion = (state: RootState) => state.version.current;

export const selectVersions = (state: RootState) => state.version;

export const selectQueryVariant = (state: RootState) => state.queryVariant;
